export const RESUME_URL =
  "https://drive.google.com/file/d/11iuQRQtlbKO_ecnXawGnJgrKBf4GVicf/view?usp=sharing";
